import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { BreadcrumbService } from "src/app/breadcrumb.service";
import {
  GetPayeStateReportsVM,
  KeyValuePairTempVM,
  LocationPAYEReportVM,
  PayGroup,
} from "src/app/interfaces/payroll";
import { PayrollService } from "src/app/services/payroll.service";

@Component({
  selector: "app-payroll-paye-state-report",
  templateUrl: "./payroll-paye-state-report.component.html",
  styleUrls: ["./payroll-paye-state-report.component.scss"],
})
export class PayrollPayeStateReportComponent implements OnInit {
  @ViewChild("formWrapper") public formWrapper: ElementRef;
  allRunTypes: KeyValuePairTempVM[];
  theRunType: KeyValuePairTempVM;
  allRunPeriods: KeyValuePairTempVM[];
  theRunPeriod: KeyValuePairTempVM;
  allPayGroups: PayGroup[];
  thePayGroup: PayGroup;
  allClients: KeyValuePairTempVM[];
  theClient: KeyValuePairTempVM;
  locationReports: LocationPAYEReportVM[];
  locationReportCols: any[];
  reportCols: any[];
  showReport: boolean = false;

  constructor(
    private fb: FormBuilder,
    private payrollService: PayrollService,
    private breadcrumbService: BreadcrumbService,
    public confirmationService: ConfirmationService,
    public messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.setItems([
      {
        label: "Payroll",
        routerLink: ["/home/payroll/payroll-settings"],
      },
      {
        label: "P.A.Y.E Report",
        routerLink: ["/home/payroll/paye-state-report"],
      },
    ]);

    this.locationReportCols = [
      { field: "state", header: "State" },
      { field: "payeAmount", header: "PayeAmount" },
      { field: "report", header: "Report" },
    ];

    this.reportCols = [
      { field: "clientName", header: "ClientName" },
      { field: "locationName", header: "LocationName" },
      { field: "clusterName", header: "ClusterName" },
      { field: "zoneName", header: "ZoneName" },
      { field: "operativeName", header: "OperativeName" },
      { field: "operativeID", header: "OperativeID" },
      { field: "payeAmount", header: "PayeAmount" },
    ];

    this.FetchFiltersDetails();
  }

  FetchFiltersDetails() {
    this.payrollService.GetPayrollVsContractRequestDits().subscribe(
      async (data) => {
        this.allRunTypes = data.runTypes;
        this.allRunPeriods = data.runPeriods;
        this.allPayGroups = data.payGroups;
        this.allClients = data.clients;
      },
      (error) => {
        console.log("Error: " + JSON.stringify(error));
        this.messageService.add({
          severity: "error",
          summary: "Notice",
          detail:
            "Unable to fetch filter details at the moment.. Reason: [" +
            (error ? error.error.message : "request failed - permission") +
            "]",
        });
      }
    );
  }

  RunCriteria() {
    this.messageService.add({
      severity: "info",
      summary: "Notice",
      detail: "Generating Report...",
    });

    this.showReport = false;
    const postData: GetPayeStateReportsVM = {
      runTypeId: this.theRunType.key,
      runPeriodId: this.theRunPeriod.key,
      runPeriodDate: this.theRunPeriod.keyDate,
      payGroupId: this.thePayGroup.id,
      clientId: this.theClient.key,
    };

    this.payrollService.GetPayeStateReports(postData).subscribe(
      async (data) => {
        if (data.responseCode != "00") {
          this.messageService.add({
            severity: "error",
            summary: "Notice",
            detail: data.responeMessage,
          });
          this.showReport = false;
          return;
        }

        this.messageService.add({
          severity: "success",
          summary: "Completed",
          detail: "Report Generated Successfully!",
        });

        this.locationReports = data.responseObject as LocationPAYEReportVM[];
        this.showReport = true;
      },
      (error) => {
        console.log("Error: " + JSON.stringify(error));
        this.messageService.add({
          severity: "error",
          summary: "Notice",
          detail:
            "Unable to generate report at the moment.. Reason: [" +
            (error ? error.error.message : "request failed - permission") +
            "]",
        });
        this.showReport = false;
      }
    );
  }
}
